<template>
    <div class="wrapper">
        <div class="main">
            <page-header/>
            <div class="section">
                <div class="container">
                    <div class="col-md-5 mx-auto">
                        <form @submit.prevent="submit" autocomplete="off">
                            <card type="login" plain>
                                <div slot="header" class="logo-container">
                                    <h2>設定</h2>
                                </div>
                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons text_caps-small"
                                          placeholder="姓名"
                                          autocomplete="off"
                                          v-model="form.name"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          addon-left-icon="now-ui-icons users_circle-08"
                                          placeholder="手機"
                                          autocomplete="off"
                                          v-model="form.phone"
                                          disabled
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          type="password"
                                          addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                                          placeholder="舊密碼"
                                          autocomplete="off"
                                          v-model="form.old_password"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          type="password"
                                          addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                                          placeholder="新密碼"
                                          autocomplete="off"
                                          v-model="form.new_password"
                                >
                                </fg-input>
                                <fg-input class="no-border input-lg"
                                          type="password"
                                          addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                                          placeholder="確認新密碼"
                                          autocomplete="off"
                                          v-model="form.new_password_confirm"
                                >
                                </fg-input>
                                <template slot="raw-content">
                                    <div class="card-footer text-center">
                                        <button type="submit" class="btn btn-outline-info btn-round btn-block">確認更改</button>
                                    </div>
                                </template>
                            </card>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Card, Button, FormGroupInput} from '@/components';
    import PageHeader from "@/views/partials/PageHeader";
    import {ME_QUERY} from "@/services/graphql/me";
    import {UserService} from "@/services/rest/user";
    import {alertSuccess, alertError} from '@/helper/alert_helper';

    export default {
        name: "LoginPage",
        components: {
            PageHeader,
            Card,
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput
        },
        data() {
            return {
                form: {
                    name: '',
                    phone: '',
                    old_password: '',
                    new_password: '',
                    new_password_confirm: ''
                }
            }
        },
        methods: {
            async getUserInfo() {
                try {
                    const q = await this.$apollo.query({
                        query: ME_QUERY,
                        fetchPolicy: "network-only"
                    });

                    if(!q.data.me) {
                        this.$router.push({name: 'Home'});
                    }

                    const me = q.data.me;

                    this.form = {
                        name: me.name,
                        phone: me.account,
                    };
                } catch (err) {
                    console.error(err);
                }
            },
            async submit() {
                try {
                    await new UserService().self(this.form);

                    this.getUserInfo();

                    alertSuccess({
                        text: '修改成功',
                    })
                } catch (err) {
                    alertError(err);
                }
            }
        },
        created() {
            this.getUserInfo();
        }
    };
</script>

<style lang="scss" scoped>
    .card-login {
        border-radius: 0.25rem;
        padding-bottom: 0.7rem;
        max-width: 320px;
    }

    .section {
        text-align: center;
    }
</style>
